enum Aggregate {
  MAX = 'MAX',
  MIN = 'MIN',
}
enum Direction {
  ASC = 'ASC',
  DESC = 'DESC',
}
type RelationOrderBy<T> = {
  column: T;
  aggregate: Aggregate;
};

export { RelationOrderBy, Aggregate, Direction };
